import { render, staticRenderFns } from "./smooth-feel.vue?vue&type=template&id=4aca1491&scoped=true&"
import script from "./smooth-feel.vue?vue&type=script&lang=js&"
export * from "./smooth-feel.vue?vue&type=script&lang=js&"
import style0 from "./smooth-feel.vue?vue&type=style&index=0&id=4aca1491&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aca1491",
  null
  
)

export default component.exports